export default "__VITE_ASSET__3c603810__"